import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";



export function useAssetsApi() {
  const callApi = useApiCall();

  const getAssetsList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSETS_LIST, data, onSuccess, onError);
  };

  const getAssetCode = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_CODE, data, onSuccess, onError);
  };
  const getAssetCategpry = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_CATEGORY, data, onSuccess, onError);
  };
  const getAssetdepartment = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_DEPARTMENT, data, onSuccess, onError);
  };

  const getAssetGrouplist = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_GROUPLIST, data, onSuccess, onError);
  }
  const getAssetSubGrouplist = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_SUBGROUPLIST, data, onSuccess, onError);
  }
  const GetAssetTypeList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_TYPE_LIST, data, onSuccess, onError);
  }

  const GetAssetClassificationList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_CLASIFICATION_LIST, data, onSuccess, onError);
  }


  const GetAssetStatusList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_STATUS_LIST, data, onSuccess, onError);
  }

  
  const GetvenderList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_VENDOR_LIST, data, onSuccess, onError);
  }

  const saveAssets = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.SAVE_ASSETS, data, onSuccess, onError);
  }
  const deleteAsset = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.DELETE_ASSETS, data, onSuccess, onError);
  }
  const updateStatus = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.UPDATE_STATUS, data, onSuccess, onError);
  }


  const GetnoteList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.NOTE_LIST, data, onSuccess, onError);
  }

  const saveNotes = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.NOTE_SAVE, data, onSuccess, onError);
  }
  const deleteNotes = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.DELETE_NOTES, data, onSuccess, onError);
  }


  const GetAttachmentList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.GET_ASSET_ATTACHMENT, data, onSuccess, onError);
  }

  const SaveAssetAttachment = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.SAVE_ASSET_ATTACHMENT, data, onSuccess, onError);
  }
  const SaveAssetImage = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.SAVE_ASSET_IMAGE, data, onSuccess, onError);
  }

  
  const DeleteAssetAttachment = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.DELETE_ASSET_ATTACHMENT, data, onSuccess, onError);
  }

  const Exportcsv = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.EXPORT_TO_CSV, data, onSuccess, onError);
  }
  const Exportpdf = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.EXPORT_TO_PDF, data, onSuccess, onError);
  }
  const ExportQrCode = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSETS.EXPORT_QR_CODE, data, onSuccess, onError);
  }

  



  return {
    getAssetsList,
    getAssetCode,
    getAssetCategpry,
    getAssetdepartment,
    getAssetGrouplist,
    getAssetSubGrouplist,
    GetAssetTypeList,
    GetAssetClassificationList,
    GetAssetStatusList,
    GetvenderList,
    saveAssets,
    deleteAsset,
    GetnoteList,
    saveNotes,
    deleteNotes,
    updateStatus,
    GetAttachmentList,
    SaveAssetAttachment,
    DeleteAssetAttachment,
    
    Exportcsv,
    Exportpdf,
    ExportQrCode,
    SaveAssetImage

  };
}
